<template>
  <div class="panel-body">
      <v-dialog persistent v-model="cardIncentivesDialog" max-width="1000px">
        <cardIncentives
          :card="this.card"
          :incentivesKey="this.cardIncentivesKey"
          @close-card-incentives="cardIncentivesClosed"
          @save-card-incentives="cardIncentivesSaved"
        ></cardIncentives>
    </v-dialog>
    <v-card>
      <template>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-card>
                <v-layout column fill-height>
                  <v-card-title>
                    <div class="teal--text display-1 font-weight-bold">{{displayTitle}}</div>
                    <v-spacer></v-spacer>
                    <v-btn dark icon>
                      <v-icon color="grey">more_vert</v-icon>
                    </v-btn>
                    <div
                      class="grey--text title font-weight-thin text-xs-right ml-0"
                    >{{displayDescription}}</div>
                  </v-card-title>
                </v-layout>
                <v-img v-if="displayImageUrl" v-bind:src="displayImageUrl" height="300px"></v-img>
              </v-card>
              <br />
              <v-btn color="blue darken-1" text @click="updatePreview">Preview</v-btn>
              <v-btn color="blue darken-1" text @click="revert">Revert</v-btn>
            </v-col>
            <v-col cols="6">
              <v-card>
                <v-container>
                  <v-row>
                    <v-text-field
                      class="ml-2 mr-2 title"
                      v-model="editCard.title"
                      label="Card title"
                      required
                      persistent-hint
                      :counter="100"
                      :rules="titleRules"
                    />
                  </v-row>
                  <v-row>
                    <v-text-field
                      class="ml-2 mr-2 description"
                      v-model="editCard.description"
                      label="Card description"
                      required
                      persistent-hint
                      :rules="nameRules"
                      :counter="100"
                    />
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :items="cardTypes"
                        label="Type"
                        v-model="editCard.type"
                        required
                        :disabled="this.card != null"
                        @change="typeChange"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="getSubTypes"
                        v-if="getSubTypes != null"
                        label="Sub Types"
                        v-model="editCard.subType"
                        color="primary"
                        :disabled="this.card != null"
                      />
                      <v-text-field
                        v-if="isTapToSaveSelected"
                        class="ml-0 onlyDigitInput"
                        v-model="editCard.amount"
                        value="defaultAmount"
                        label="Amount"
                        type="number"
                        :rules="[amountFormat]"
                        pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
                        prefix="$"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-text-field class="ml-2 mr-2" v-model="editCard.imageUrl" label="Image URL" required :counter="200"></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                    v-if="!isChallengeType"
                      class="ml-2 mr-2"
                      v-model="editCard.informationUrl"
                      :label= infoUrlLabel()
                      required
                      :counter="750"
                    />
                    <v-select
                    v-if="isChallengeType"
                      class="ml-2 mr-2"
                      :items="challengeTemplates"
                      v-model="editCard.informationUrl"
                      :label= infoUrlLabel()
                      required
                      :counter="750"
                    />
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <v-slider
                        v-model="editCard.priority"
                        class="mt-2"
                        :label="priorityLabel"
                        :max="max"
                        :min="min"
                        thumb-label="always"
                        :thumb-size="18"
                        :thumb-color="pickerThumbColour"
                        @change="validatePriorityChange"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-switch :disabled="this.editCard.type !== 'banner'" v-model="editCard.expandOnLoad" color="primary" class="mt-2" label="Expanded"></v-switch>
                    </v-col>
                    <v-col cols="4">
                      <v-switch v-model="editCard.userDismissible" color="primary" class="mt-2" label="Dismissable"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        clearable
                        :items="groups"
                        label="Group"
                        v-model="editCard.groupId"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayStartDateTime"
                            label="Start Date"
                            persistent-hint
                            hint="Choose date/time for card to start."
                            class="mr-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            required
                          />
                        </template>
                        <v-card>
                          <!-- <v-date-picker v-model="displayStartDate" v-on:click:date="startDateMenu = false; startTimeMenu = true"></v-date-picker> -->
                          <v-date-picker v-model="displayStartDate" :min="nowDate" :max="getEndDate">
                          </v-date-picker>
                          <v-time-picker
                            v-model="displayStartTime"
                            format="24hr"
                            @click:minute="startDateMenu = false;setStartDateTime()"
                          >
                          </v-time-picker>
                          <v-spacer></v-spacer>
                          <v-flex class="text-xs-right">
                            <v-btn text color="red" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="menu = false">OK</v-btn>
                          </v-flex>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayEndDateTime"
                            label="End Date"
                            persistent-hint
                            hint="Choose end date/time for card. If no end date, click 'X' and clear field."
                            class="ml-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearEndDateTime()"
                          />
                        </template>
                        <v-date-picker v-model="displayEndDate" :min="nowDate" :max="getEndDate">
                        </v-date-picker>
                        <v-time-picker
                          v-model="displayEndTime"
                          format="24hr"
                          @click:minute="endDateMenu = false;setEndDateTime()"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
                <br />
              </v-card>
            </v-col>
          </v-row>
          <v-layout wrap>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" v-if="this.card != null" text @click="openIncentivesDialog">Incentives</v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn v-if="this.editCard" color="blue darken-1"  :disabled="!valid || isTitleDescEmpty"  text @click="save">Save</v-btn>
          </v-layout>
        </v-container>
      </template>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import cardIncentives from '@/components/CardIncentives.vue'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    card: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    min: 0,
    max: 10,
    startDateMenu: null,
    startTimeMenu: null,
    endDateMenu: null,
    endTimeMenu: null,
    localDate: null,
    cards: [],
    nowDate: new Date().toISOString().slice(0, 10),
    date: new Date(),
    picker: new Date().toISOString().substr(0, 10),
    pickerThumbColour: 'primary',
    dateTimeDialog: false,
    dialog: false,
    displayTitle: '',
    displayDescription: '',
    displayStartDate: null,
    displayStartTime: null,
    displayStartDateTime: null,
    displayEndDate: null,
    displayEndTime: null,
    displayEndDateTime: null,
    displayImageUrl: null,
    priorityLabel: 'Priority',
    priority: null,
    valid: true,
    challengeTemplates: [],
    isChallengeType: false,
    enableAmount: true,
    nameRules: [
      v => !!v || 'This is required',
      v => (v && v.length <= 250) || 'This must be less than or equal to 250 characters'
    ],
    titleRules: [
      v => !!v || 'This is required'
    ],
    defaultItem: {
      title: 'This is your title', // 'This is your title',
      description: 'This is your Description', // 'This is your Description',
      type: 'information',
      imageUrl: null,
      informationUrl: null,
      startDate: moment().toISOString(),
      endDate: null
    },
    todaysDate: moment(new Date()).toISOString,
    maxDate: moment().add(365, 'days').calendar().toISOString,
    cardTypes: [ { text: 'Information', value: 'information' }, { text: 'Tap to Save', value: 'recommendation' }, { text: 'Banner', value: 'banner' }, { text: 'Challenge', value: 'challenge' } ],
    groups: [],
    loadingGroups: false,
    cardSubTypes: new Map([
      ['information', [{ text: 'Web', value: 'web' }, { text: 'In App', value: 'inapp' }]],
      ['banner', [{ text: 'Web', value: 'web' }, { text: 'In App', value: 'inapp' }]]
    ]),
    editCard: null,
    reccomAmount: false,
    defaultAmount: '5',
    cardIncentivesDialog: false,
    cardIncentivesKey: 0,
    challengeSelected: false
  }),

  created () {
    this.initialize()
  },
  mounted () {
    this.initialize()
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dateTimeDialog (val) {},
    card: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (!newValue) {
          this.editCard = JSON.parse(JSON.stringify(this.defaultItem))
        } else {
        //  this.editCard = JSON.parse(JSON.stringify(newValue))
          var editCard = JSON.parse(JSON.stringify(newValue))
          if (editCard.recommendationType === 'challenge') {
            editCard.type = 'challenge'
          }

          this.editCard = editCard
        }
        // Check for null or 0
        if (this.editCard.priority == null || this.editCard.priority === 0) {
          this.editCard.priority = null
          this.pickerThumbColour = 'red'
        } else {
          this.pickerThumbColour = 'primary'
        }
        this.setupEdit()
      }
    }
  },
  components: {
    cardIncentives
  },
  computed: {
    getEndDate () {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 12, 10)
      return endDate.toISOString().slice(0, 10)
    },
    isTitleDescEmpty () {
      return !(this.editCard.title && this.editCard.description)
    },
    isTapToSaveSelected () {
      return this.editCard.type === 'recommendation'
    },
    isShowSubType () {
      return this.editCard.type === 'recommendation'
    },
    isShowAmount () {
      return this.editCard.type === 'recommendation'
    },
    getSubTypes () {
      return this.cardSubTypes.get(this.editCard.type)
    }
  },
  methods: {
    initialize () {
      this.loadGroups()
      this.getChallengeTemplates()
      if (!this.card) this.editCard = JSON.parse(JSON.stringify(this.defaultItem))
    },
    close () {
      delete this.editCard
      this.$emit('close-card')
    },
    amountFormat (value) {
      if (!value || value === undefined || typeof value === 'number' || value.match('^[0-9]+(.[0-9]{1,2})?$')) return true
      else return 'Amount format invalid'
    },
    async getChallengeTemplates () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_TEMPLATE}/templates/saving-goals/group/1`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.challengeTemplates = getResponse.data.map(template => {
        var challengeTypeId = template.id
        var chalengeTypeName = template.jar.name
        let properties = {
          'text': chalengeTypeName,
          'value': challengeTypeId + '-' + chalengeTypeName
        }
        return properties
      })

      /* for (let i = 0; i < getResponse.data.length; i++) {
        var challengeTypeId = getResponse.data[i].id
        var chalengeTypeName = getResponse.data[i].jar.name
        var challengeTemplate = challengeTypeId + '-' + chalengeTypeName
        this.challengeTemplates[i] = challengeTemplate
      } */
    },
    async save () {
      if (this.editCard) {
        // Create copy of editCard
        if (this.editCard.priority === 0) {
          this.editCard.priority = null
        }

        if (this.editCard.type === 'challenge') {
          this.editCard.type = 'recommendation'
          this.editCard.recommendationType = 'challenge'
        }

        var editCardCopy = this.editCard

        // Stringify editCardCopy
        editCardCopy = JSON.stringify(editCardCopy)

        const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_CARDS}/cards`
        var postResponse

        // If doesn't contain card, it's a new card
        if (this.card != null) {
          postResponse = await rh.default.patch(endpoint, editCardCopy, true).catch(e => {
            this.errors.push(e)
          })
        } else {
          postResponse = await rh.default.put(endpoint, editCardCopy, true).catch(e => {
            this.errors.push(e)
          })
        }
        this.$emit('save-card', JSON.stringify(postResponse.data))
      }
    },
    infoUrlLabel () {
      if (this.editCard.type === 'challenge') {
        // this.editCard.type = 'recommendation'
        this.isChallengeType = true
        return 'Link of Challenge template'
      } else {
        this.isChallengeType = false
        // this.editCard.informationUrl = this.defaultItem.informationUrl
        return 'Info URL'
      }
    },
    async updatePreview () {
      this.displayImageUrl = this.editCard.imageUrl
      this.displayTitle = await mh.default.formatMessage(this.editCard.title)
      this.displayDescription = await mh.default.formatMessage(
        this.editCard.description
      )
    },
    revert () {
      this.editCard = JSON.parse(JSON.stringify(this.card))
      this.setupEdit()
    },
    setStartDateTime () {
      this.localDate = moment(
        this.displayStartDate + ' ' + this.displayStartTime
      )
      this.editCard.startDate = moment.utc(this.localDate).toISOString()
      this.displayStartDate = this.formatDate(this.editCard.startDate)
      this.displayStartTime = this.formatTime(this.editCard.startDate)
      this.displayStartDateTime = this.formatDateTime(this.editCard.startDate)
    },
    clearEndDateTime () {
      this.editCard.endDate = null
      this.localDate = null
      this.displayEndDate = ''
      this.displayEndTime = ''
      this.displayEndDateTime = ''
    },
    setEndDateTime () {
      this.localDate = moment(
        this.displayEndDate + ' ' + this.displayEndTime
      )
      this.editCard.endDate = moment.utc(this.localDate).toISOString()
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)
    },
    async setupEdit () {
      if (!this.editCard) {
        this.editCard = this.defaultItem
        return
      }
      // this.editCard = JSON.parse(JSON.stringify(newValue))
      this.displayImageUrl = this.editCard.imageUrl
      this.displayStartDate = this.formatDate(this.editCard.startDate)
      this.displayStartTime = this.formatTime(this.editCard.startDate)
      this.displayStartDateTime = this.formatDateTime(this.editCard.startDate)
      this.localDate = !this.editCard.endDate ? null : moment(this.editCard.endDate)
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)
      this.displayTitle = await mh.default.formatMessage(this.editCard.title)
      this.displayDescription = await mh.default.formatMessage(
        this.editCard.description
      )
    },
    formatDateTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD HH:mm')
    },
    formatDate (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD')
    },
    formatTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('HH:mm')
    },
    validatePriorityChange () {
      if (this.editCard.priority === 0) {
        this.pickerThumbColour = 'red'
        this.editCard.priority = null
      } else {
        this.pickerThumbColour = 'primary'
      }
    },
    typeChange () {
      if (this.card != null) {
        this.editCard.subType = this.card.subType
        this.editCard.amount = this.card.amount
      } else {
        this.editCard.subType = null
        this.editCard.amount = this.defaultAmount
        if (this.editCard.informationUrl != null) {
          this.editCard.informationUrl = null
        }
      }
    },
    async loadGroups () {
      this.groups = []

      this.loadingGroups = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups?all=true`

      var getResponse = await rh.default.get(endpoint, true).catch((e) => {
        this.errors.push(e)
        throw e
      })
      if (
        getResponse !== undefined &&
        getResponse.data !== undefined &&
        getResponse.data.length > 0
      ) {
        // this.groups = getResponse.data
        this.groups = getResponse.data.map(group => {
          let properties = {
            'text': group.name,
            'value': group.id
          }
          return properties
        })
      }
      this.loadingGroups = false
    },
    cardIncentivesClosed () {
      this.cardIncentivesDialog = false
    },
    cardIncentivesSaved () {
      this.cardIncentivesDialog = false
    },
    openIncentivesDialog () {
      this.cardIncentivesKey++
      this.cardIncentivesDialog = true
    }
  }
}
</script>
<style>
.onlyDigitInput input[type="number"] {
  -moz-appearance: textfield;
}
.onlyDigitInput input::-webkit-outer-spin-button,
.onlyDigitInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
